import React from 'react'
import { Box, Typography } from '@mui/material'
import { WalletCardDownloadProps } from './WalletCardDownload.types'
import { useWalletCardDownload } from './WalletCardDownload.logic'

const WalletCardDownload: React.FC<WalletCardDownloadProps> = (props) => {
  const { handleWalletDownload, handleAppleWalletDownload } =
    useWalletCardDownload(props)

  return (
    <Box textAlign="center">
      <Typography variant="h2" gutterBottom>
        Your wallet card is ready!
      </Typography>

      <Typography variant="body1" paragraph maxWidth="60ch">
        Choose your preferred digital wallet format below to download your
        medical device wallet card.
      </Typography>

      <Box display="flex" justifyContent="center" gap={2} mt={6}>
        <button
          className="wallet-card-download-button"
          onClick={handleAppleWalletDownload}
        >
          <img height="40" src="/apple-wallet-icon.svg" alt="Apple Wallet" />
        </button>
        <button
          className="wallet-card-download-button"
          onClick={() => handleWalletDownload('google')}
        >
          <img height="42" src="/google-wallet-icon.svg" alt="Google Wallet" />
        </button>
      </Box>
    </Box>
  )
}

export default WalletCardDownload
